import { render, staticRenderFns } from "./balanceList.vue?vue&type=template&id=2280e510&scoped=true"
import script from "./balanceList.vue?vue&type=script&lang=js"
export * from "./balanceList.vue?vue&type=script&lang=js"
import style0 from "./balanceList.vue?vue&type=style&index=0&id=2280e510&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280e510",
  null
  
)

export default component.exports